import { render, staticRenderFns } from "./Aulas.vue?vue&type=template&id=b1a8c21a&scoped=true"
import script from "./Aulas.vue?vue&type=script&lang=js"
export * from "./Aulas.vue?vue&type=script&lang=js"
import style0 from "./Aulas.vue?vue&type=style&index=0&id=b1a8c21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a8c21a",
  null
  
)

export default component.exports